import { AlpineComponent } from "alpinejs";

type DownloadDocumentTracker = AlpineComponent<{
	trackDocumentDownload: (trackingEventName: string) => void;
}>;

export default (): DownloadDocumentTracker => {
	return {
		trackDocumentDownload(trackingEventName: string) {
			if (trackingEventName === "NoTrack") {
				return;
			}
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: trackingEventName,
			});
		},
	};
};
